import './App.css';
import NavbarComponent from './Components/NavbarComponent';
import Home from './Pages/HomePage';
import About from './Pages/AboutPage';
import Projects from './Pages/ProjectsPage';
import Resume from './Pages/ResumePage';
import Contact from './Pages/ContactPage';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
  return (
    <div className="App">
      <Router>
        <NavbarComponent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Homepage" element={<Home />} />
          <Route path="/AboutPage" element={<About />} />
          <Route path="/ProjectsPage" element={<Projects />} />
          <Route path="/ResumePage" element={<Resume />} />
          <Route path="/ContactPage" element={<Contact />} />
        </Routes>
      </Router>
    </div>
  );
}